// this file use for communication between Render Thread an Main Thread

import ViewUtil from '../ViewUtil';
import { SUBTAB } from './Constants';
type listenerType = {
  name: string,
  path: string
}
const isElectron = function () {
  return window.process ? true : false;
};
const PROCESS_ARGS = 'PROCESS_ARGS';
let CMD_ARGS = {};
const electron = isElectron() ? window.require('electron') : null;
const ipcRenderer = electron ? electron.ipcRenderer : null;

export const directorySelector = (onSelect, listener: listenerType) => {
  ipcRenderer.send('select-dirs', listener);
  ipcRenderer.on(listener.name, (event, message) => {
    onSelect(message);
  });
};

export const checkDirecoryExisting = (paths, cb) => {
  console.log(paths, 'Paths');
  ipcRenderer.send('CHECK_FOLDER_PATH', { paths });
  ipcRenderer.on('CHECK_DIRECTORY_EXIST', (event, message) => {
    cb(message);
  });
};

export const unregisterListner = (listener, cb = () => { }) => {
  ipcRenderer.removeListener(listener, cb);
};

export const setMainThreadListner = function (cb) {
  if (ipcRenderer) {
    CMD_ARGS = ipcRenderer.sendSync(PROCESS_ARGS);
    cb();
    ipcRenderer.on('argsChange', function (event, message) {
      CMD_ARGS = message;
      actionOnInit(CMD_ARGS, true);
    });
  }
};

export const actionOnInit = function (args = CMD_ARGS, isRunning: boolean = false) {
  if (_.has(args, 'collectionId')) {
    const collectionId = _.get(args, 'collectionId');
    if (isRunning) ViewUtil.switchToCollectionId(collectionId);
    else window.setARGS({ activeTab: 'COLLECTIONS', activeSubTab: SUBTAB.ALL.KEY, collectionId });

    if (_.has(args, 'fuid')) {
      const fuid = _.get(args, 'fuid');
      window.setARGS({ ...window.ARGS, fuid: fuid });
      if (_.has(args, 'tId')) {
        const tId = _.get(args, 'tId');
        window.setARGS({ ...window.ARGS, tId: tId });
      }
    }
    if (isRunning) window.render();
    return;
  }

  if (_.has(args, 'fuid')) {
    const fuid = _.get(args, 'fuid');
    if (isRunning) {
      window.gs.forceLoadDetailsView = true;
      ViewUtil.switchToAssetDetailView(fuid, true);
    } else {
      window.setARGS({ activeTab: 'ASSETS', fuid });
    }
    return;
  }
  if (_.has(args, 'findText')) {
    const findText = _.get(args, 'findText');
    if (isRunning) {
      if (window.gs.AutoCompleteGlobalSearchRef && findText) {
        window.gs.AutoCompleteGlobalSearchRef.getSearchQuery(findText);
      }
    } else {
      window.findText = findText;
      window.setARGS({ activeTab: 'ASSETS' });
    }
  }

  if (_.has(args, 'activeTab')) {
    const activeTab = _.get(args, 'activeTab');
    window.setARGS({ ...window.ARGS, activeTab: activeTab });
    if (isRunning) window.render();
    return;
  }
  /*if (_.has(args, 'server')) {
  }
  if (_.has(args, 'project')) {
  }
  if (_.has(args, 'branch')) {
  }
  if (_.has(args, 'remote')) {
  }
  
  if (_.has(args, 'uberSearchStr')) {
  }
  if (_.has(args, 'openTaskManager')) {
  }
  if (_.has(args, 'zm_username')) {
  }
  if (_.has(args, 'zm_cookie')) {
  }
  if (_.has(args, 'zm_password')) {
  }
  if (_.has(args, 'collectionId')) {
  }
  if (_.has(args, 'ignoreVideoLx')) {
  }
  if (_.has(args, 'ignoreImgSeq')) {
  }
  if (_.has(args, 'mainFileFuid')) {
  }*/
};
